import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { ONE_HOUR_MS, THIRTY_MINUTES_MS } from "../constants";

function createDefaultQueryClient() {
  const queryCache = new QueryCache();
  const mutationCache = new MutationCache();

  return new QueryClient({
    queryCache,
    mutationCache,
    defaultOptions: {
      queries: {
        staleTime: THIRTY_MINUTES_MS,
        gcTime: ONE_HOUR_MS, // keep cached data for an hour by default
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        refetchOnMount: false,
        retry: (failureCount, error) => {
          if (error?.status === 401 || error?.status === 403) return false;
          return failureCount < 2;
        },
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export const queryClient = createDefaultQueryClient();

export function resetQueryClient() {
  queryClient.clear();
}
